import { Button, Card, Form, Input, Modal, Popconfirm } from 'antd'
import React, { useState } from 'react'
import service from '../../services/documentRepoService'
import { recordError } from "../../utils/logService";

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

export default function DeleteDocument(props) {

  const [currentId, setCurrentId] = useState(props.record?.id);

  const [form] = Form.useForm();
  const formName = "DeleteDocument";

  let msg = "";

  const Confirm = () => {
    form.resetFields();
    props.onShow(false);
  };

  const handleCancel = () => {

    if (form.getFieldValue("notes")) {
    } else {
      form.resetFields();
      props.onShow(false);
    }
  };
  const deleteDocument = async (values) => {
    const data = {
      id: currentId,
      notes: values.notes,
      ratified: true
    }
    try {
      const response =
        (props.modalType === "delete") ?
          await service.deleteDocument(data)
          :
          await service.deleteRatifiedDocument(data);
      if (response && response.status === 200) {

        msg = util.parseMessage(Messages.DELETE_SUCCESS, "Documents");
        openNotification("Document Deletion", msg, Notify.SUCCESS);
        props.setHasUpdated(!props.hasUpdated);
        props.onShow(false);
        return;
      }

      msg = util.parseMessage(Messages.DELETE_FAILURE, "Documents");
      openNotification("Document Deletion Failed", msg, Notify.ERROR);
    } catch (error) {
      recordError(error);
      msg = util.parseMessage(Messages.DELETE_FAILURE, "Documents");
      openNotification("Document Deletion Failed", msg, Notify.ERROR);
    }
  };

  return (
    <>
      <Modal
        forceRender
        title={"Delete record confirmation"}
        open={props.record}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={500}
        footer={[
          <div className="modal-footer-buttons">
            <Button
              key="2"
              type="danger"
              htmlType="submit"
              form={formName}
            >
              Confirm
            </Button>
            <Popconfirm
              key="1"
              title="Are you sure you want to cancel...you will lose all info entered?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => Confirm()}
              onCancel={() => handleCancel()}
            >
              <Button
                onMouseUp={() => handleCancel()}
                style={{ marginLeft: 10 }}
              >
                Cancel
              </Button>
            </Popconfirm>
          </div>,
        ]}
      >
        <Form
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
          name={formName}
          onFinish={deleteDocument}
        >
          <Form.Item
            hidden={true}
            name="id"
            label="id"
          >
            <Input name="id" />
          </Form.Item>
          <Form.Item
            name="notes"
            label="Notes"
            rules={[
              {
                required: true,
                message: "Please provide reason",
              },
            ]}
          >
            <Input name="notes" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
